var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAem(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    rx: 22,
    fill: "rgba(235, 16, 0, 0.15)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 24 L78 68 C78.5 69.5 77.5 71 76 71 L66 71 C64.8 71 63.8 70.3 63.4 69.2 L58 54 L44.5 54 L54.5 25.5 C55.2 23.5 57.5 22.5 59.5 23.2 C60.8 23.6 61.9 24.8 62.5 24 Z",
    fill: "#EB1000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 24 L22 68 C21.5 69.5 22.5 71 24 71 L34 71 C35.2 71 36.2 70.3 36.6 69.2 L42 54 L55.5 54 L45.5 25.5 C44.8 23.5 42.5 22.5 40.5 23.2 C39.2 23.6 38.1 24.8 37.5 24 Z",
    fill: "#EB1000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAem);
export default __webpack_public_path__ + "static/media/aem.57dad03ff87af2883c4e7c84de532d7f.svg";
export { ForwardRef as ReactComponent };